/**
 * SetsCtrl controller
 * Show all category sets
 */

import { ENTITY_TYPES } from 'app/core/constants'
import { getName, remove } from 'app/helpers/entity'

/**
 * SetsCtrl controller
 *
 * @class SetsCtrl
 * @memberof mwApp/sets
 * @see mwApp/sets
 *
 * @ngdoc controller
 * @name mwApp/sets.controller:SetsCtrl
 */
/* @ngInject */
export default function SetsCtrl ($state, $scope, $uibModal, $transition$, CategorySet, Category, SubCategory, authSvc, type) {
  var vm = this

  if (type === 'radio' && !authSvc.hasEnabledFlag('FEATURE_RADIO_CHANNELS_ENABLED')) {
    return $state.go('app.404')
  }

  var CSType = vm.CSType = ENTITY_TYPES[type] // category set type, 'Radio' | 'TV' | 'VOD'

  // default modal config
  var modalCfg = {
    animation: false,
    size: 'lg'
  }

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  // request initial data
  CategorySet.loadAll('?type=' + (CSType === 'Series' ? 'TV_SHOW' : CSType))
    .to(vm.sets = [])
    .then(() => {
      vm.sets.forEach((set) => {
        set.categories.forEach((category) => {
          category.categorySet = set
          category.subCategories.forEach(sc => {
            sc.categorySet = set
          })
        })
      })
      $scope.loading = false
    })

  /**
   * Move Categories and SubCategories up and down
   */
  vm.up = function (c, $event) {
    vm.stopEvent($event)
    if (!vm.changeCategoryOrder) {
      vm.changeCategoryOrder = true
      c._up(
        c.parentCategory
          ? c.parentCategory.subCategories
          : (c.categorySet ? c.categorySet.categories : null)
      ).finally(() => {
        vm.changeCategoryOrder = false
      })
    }
  }
  vm.down = function (c, $event) {
    vm.stopEvent($event)
    if (!vm.changeCategoryOrder) {
      vm.changeCategoryOrder = true
      c._down(
        c.parentCategory
          ? c.parentCategory.subCategories
          : (c.categorySet ? c.categorySet.categories : null)
      ).finally(() => {
        vm.changeCategoryOrder = false
      })
    }
  }

  /**
   * Opens 'Add/Edit Category Set' modal window
   */
  vm.editCategorySet = vm.addCategorySet = function (set, $event) {
    vm.stopEvent($event)

    var isNew = !set
    var initialCS = angular.copy(set) // initial state
    $uibModal.open(angular.extend({}, modalCfg, {
      templateUrl: 'components/sets/views/addCategorySet.html',
      controller: 'AddCategorySetCtrl as vm',
      resolve: {
        cs: () => (
          !isNew
            ? set
            : new CategorySet({ categorySetType: CSType === 'Series' ? 'TV_SHOW' : CSType })
        ),
        categorySetNames: () => vm.sets.map(getName)
      }
    })).result
      .then(
        set => {
          if (isNew) {
            vm.sets.push(set)
          } else {
            var __open = set.__open
            set._update()
              .then(() => {
                set.__open = __open
                set.categories.forEach(cat => {
                  cat.__expanded = false
                  cat.categorySet = set
                  cat.subCategories.forEach(sc => {
                    sc.categorySet = set
                  })
                })
              })
          }
        }
      )
      .catch(
        () => angular.copy(initialCS, set) // restore set on dismiss modal window
      )
  }

  /**
   * Deletes category set
   */
  vm.deleteCategorySet = function (set) {
    set._delete()
      .then(remove(vm.sets)(set))
  }

  /**
   * Opens 'Add/Edit Category' modal window
   */
  vm.editCategory = vm.addCategory = function (cat, set, $event) {
    vm.stopEvent($event)

    var isNew = !cat
    var initialCat = angular.copy(cat) // initial state
    $uibModal.open(angular.extend({}, modalCfg, {
      templateUrl: 'components/sets/views/addCategory.html',
      controller: 'AddCategoryCtrl as vm',
      resolve: {
        cat: () => (
          !isNew
            ? cat
            // create Category doing skinDeep=true constructor (don't go recursion, just copy fields)
            : new Category({ categorySet: set }, null, true)
        ),
        categoryNames: () => set.categories.map(getName)
      }
    })).result
      .catch(
        () => angular.copy(initialCat, cat) // restore category on dismiss modal window
      )
  }

  /**
   * Deletes category
   */
  vm.deleteCategory = function (cat) {
    cat._delete()
    // we don't need to remove category from parent categoryset
    // because ._delete() already did it
  }

  /**
   * Opens 'Add/Edit Sub Category' modal window
   */
  vm.editSubCategory = vm.addSubCategory = function (sc, cat, set, $event) {
    vm.stopEvent($event)

    var isNew = !sc
    var initialSC = angular.copy(sc) // initial state
    $uibModal.open(angular.extend({}, modalCfg, {
      templateUrl: 'components/sets/views/addSubCategory.html',
      controller: 'AddSubCategoryCtrl as vm',
      resolve: {
        sc: () => (
          !isNew
            ? sc
            // create SubCategory doing skinDeep=true constructor (don't go recursion, just copy fields)
            : new SubCategory({ parentCategory: cat, categorySet: set }, null, true)
        ),
        subCategoryNames: () => cat.subCategories.map(getName)
      }
    })).result
      .catch(
        () => angular.copy(initialSC, sc) // restore sub category on dismiss modal window
      )
  }

  /**
   * Deletes subcategory
   */
  vm.deleteSubCategory = function (sc) {
    sc._delete()
    // we don't need to remove subcategory from parent category
    // because ._delete() already did it
  }

  /**
   * Display 'Add/Edit TV Channels' modal window
   */
  vm.editChannels = function (cat, set) {
    var initialCat = angular.copy(cat) // initial state
    $uibModal.open(angular.extend({}, modalCfg, {
      templateUrl: 'components/sets/views/addChannels.html',
      controller: 'AddChannelsCtrl as vm',
      resolve: {
        cat: () => cat,
        set: () => set
      }
    })).result
      .catch(
        () => angular.copy(initialCat, cat) // restore category on dismiss modal window
      )
  }

  /**
   * Deletes channel from category
   */
  vm.deleteChannel = function (cat, ch) {
    remove(cat.channels)(ch)()
    cat._clone()
      ._modify(
        cat => {
          cat.categorySet = null
          cat.parentCategory = null
          cat.subCategories = null
          cat.sortOrder = null
        }
      )
      ._save()
  }
}
